import { createCrudSlice } from '@crm/features/crudSliceFactory';

const module = createCrudSlice({
  name: 'crmSales',
  path: 'sales',
  singleKey: 'sale',
});

export const salesActions = module.actions;
export const salesThunks = module.thunks;
export const salesSelectors = module.selectors;
export default module.reducer;
